export const TXTCLI_Promotions = {
  "id": "TXTCLI_Promotions",
  "defaultMessage": "Promotions"
} as const;

export const TXTCLI_Settings = {
  "id": "TXTCLI_Settings",
  "defaultMessage": "Settings"
} as const;

export const TXTCLI_Withdraw = {
  "id": "TXTCLI_Withdraw",
  "defaultMessage": "Withdraw"
} as const;

export const TXTWCL_Home_7 = {
  "id": "TXTWCL_Home_7",
  "defaultMessage": "Home"
} as const;

export const TXTWCL_In_Play = {
  "id": "TXTWCL_In_Play",
  "defaultMessage": "In-Play"
} as const;

export const TXTWCL_My_Bets = {
  "id": "TXTWCL_My_Bets",
  "defaultMessage": "My Bets"
} as const;

export const TXTWCL_Close = {
  "id": "TXTWCL_Close",
  "defaultMessage": "Close"
} as const;

export const TXTWCL_Search = {
  "id": "TXTWCL_Search",
  "defaultMessage": "Search"
} as const;